var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flickity',{ref:"flickity",attrs:{"options":_vm.flickityOptions}},_vm._l((_vm.products),function(i){return _c('recommended-product-card',{key:i,attrs:{"product_id":i,"user_type":_vm.user_type}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }